'use strict';

class FeedItem extends HTMLElement {
  attachedCallback() {
    this.innerText = this.text
  }
}

document.registerElement('feed-item', FeedItem)

export default FeedItem
